import React from 'react'

import AccountFormInput from 'pages/User/components/AccountFormInput'

const CompanyInfoSection = ({ formData, handleInputChange, errors }) => (
  <div className="mt-6 p-6 bg-slate-50 rounded-lg border border-slate-200">
    <div className="mb-4 p-3 bg-amber-50 border-l-4 border-amber-400 rounded-lg">
      <p className="text-[13px] text-amber-500">
        <i className="fas fa-exclamation-triangle mr-1"></i>
        იურიდიული პირის მონაცემების შევსების შემთხვევაში ყველა მომდევნო შეკვეთა
        გაფორმდება იურიდიულ პირზე.
      </p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <AccountFormInput
          label="კომპანიის დასახელება"
          name="companyName"
          value={formData.companyName}
          onChange={handleInputChange}
          placeholder="კომპანიის დასახელება"
        />
        {errors['details.company_name'] && (
          <p className="text-red-500 text-xs mt-1">
            {errors['details.company_name']}
          </p>
        )}
      </div>
      <div>
        <AccountFormInput
          label="საიდენტიფიკაციო კოდი"
          name="companyId"
          value={formData.companyId}
          onChange={handleInputChange}
          placeholder="123456789"
        />
        {errors['details.company_code'] && (
          <p className="text-red-500 text-xs mt-1">
            {errors['details.company_code']}
          </p>
        )}
      </div>
    </div>
  </div>
)

export default CompanyInfoSection
